module.exports = __webpack_public_path__ + "static/media/icon-search.d91580c0.svg";